export const SET_MENTION_OWNERS = 'SET_MENTION_OWNERS';
export const SET_COMMENTS_LOADING = 'SET_COMMENTS_LOADING';
export const SET_SNIPPETS_LOADING = 'SET_SNIPPETS_LOADING';
export const GET_COMMENTS = 'GET_COMMENTS';
export const SET_COMMENTS = 'SET_COMMENTS';
export const CREATE_COMMENT = 'CREATE_COMMENT';
export const SET_NEW_COMMENT = 'SET_NEW_COMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const DELETE_STORE_COMMENT = 'DELETE_STORE_COMMENT';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const UPDATE_STORE_COMMENT = 'UPDATE_STORE_COMMENT';
export const initialState = {
  comments: [],
  isLoading: false,
  owners: [],
  isOwnersLoaded: false,
  isSnippetLoading: false
};
export const reducer = (state, action) => {
  switch (action.type) {
    case SET_MENTION_OWNERS:
      return Object.assign({}, state, {
        owners: action.payload,
        isOwnersLoaded: true
      });
    case SET_COMMENTS_LOADING:
      return Object.assign({}, state, {
        isLoading: action.payload
      });
    case SET_SNIPPETS_LOADING:
      return Object.assign({}, state, {
        isSnippetLoading: action.payload
      });
    case SET_COMMENTS:
      return Object.assign({}, state, {
        isLoading: false,
        comments: action.payload
      });
    case SET_NEW_COMMENT:
      return Object.assign({}, state, {
        isLoading: false,
        comments: [...state.comments, action.payload]
      });
    case DELETE_STORE_COMMENT:
      return Object.assign({}, state, {
        isLoading: false,
        comments: state.comments.filter(comment => comment.commentId !== action.payload)
      });
    case UPDATE_STORE_COMMENT:
      return Object.assign({}, state, {
        isLoading: false,
        comments: state.comments.map(comment => {
          if (comment.commentId === action.payload.commentId) {
            return action.payload;
          }
          return comment;
        })
      });
    default:
      return state;
  }
};